import { Injectable } from '@angular/core';

import { HubFrequentDriverListFacade } from './hub-frequent-driver-list.facade';

@Injectable({
  providedIn: 'root',
})
export class HubFrequentDriverAutocompleteGuard  {
  constructor(private hubFrequentDriverListFacade: HubFrequentDriverListFacade) {}

  canDeactivate(): boolean {
    this.hubFrequentDriverListFacade.setInitialStateForAutocomplete();

    return true;
  }
}
